import { render, staticRenderFns } from "./UserWatchlistIndex.vue?vue&type=template&id=7d153e03&scoped=true"
import script from "./UserWatchlistIndex.vue?vue&type=script&lang=js"
export * from "./UserWatchlistIndex.vue?vue&type=script&lang=js"
import style0 from "./UserWatchlistIndex.vue?vue&type=style&index=0&id=7d153e03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d153e03",
  null
  
)

export default component.exports